import React from 'react'
import Picture from '../Picture'
import AnchorLink from '../AnchorLink'
import classNames from 'classnames'

/**
 * React News element
 * @param {String} title - Specify the title <h2> of the module
 * @param {String} href - link to full news page
 * @param {Array} items - Array of Objects representing news items
 */

const News = ({
  title = '',
  href = '',
  linkText = '',
  trackingName = '',
  items = []
}) => {
  let headerContent
  // Settings for all sources of the video thumbnail images
  let allSources = [ {
    config: [ {
      combinerOptions: {
        w: 120,
        h: 120
      }
    } ]
  } ]

  if (href) {
    headerContent = [
      <h1 key="h">{title}</h1>,
      <AnchorLink
        key="a"
        to={href}
        text={linkText}
        className="header-link icon-font-after icon-caret-sm-right-after"
        name={trackingName}
      />
    ]
  } else {
    headerContent = <h1>{title}</h1>
  }

  const newsModule = (
    <article className="sub-module sub-module-news">
      <header className={classNames( { 'has-link' :  href } )}>
        {headerContent}
      </header>
      <ul className="content">
        {
          items.map((news,i) => {
            const text = [
              <h2 key="h"><a href={news.href} name={news.trackingName}>{news.headline}</a></h2>,
              <p key="p">{news.description}</p>
            ]

            const { image = {}, video = {} } = news
            const thumbnailUrl = video.thumbnail || image.url

            return (
              <li className={classNames('text-container', { 'no-thumb': image.url })} key={i}>
                { !thumbnailUrl ? text :
                  [ <figure key="f" className="feed-item-figure">
                      <a href={news.href} className="img-wrap" name={news.trackingName}>
                        <Picture
                          thumbnail = { thumbnailUrl }
                          imgClasses = { { lazyload : true } }
                          allSources = { allSources }
                        />
                      </a>
                    </figure>,
                    <div key="d" className="text-container">
                      {text}
                    </div>
                  ]
                }
              </li>
            )
          })
        }
      </ul>
    </article>
  )

  return items.length ? newsModule : <aside className="sub-module sub-module-news"/>
}

export default News



// WEBPACK FOOTER //
// ../app/components/common/col-c/News.jsx